module.exports = __webpack_public_path__ + "static/media/East_Hall-c-f.254211d5.webp";